import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import logo from "../../assets/images/logo.svg";
import errorAvatar from "../../assets/images/error-avatar.svg";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.error('Error caught by ErrorBoundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      const { error } = this.state;
      return (
        <div className="flex flex-col items-center justify-center h-screen relative">
          <img src={logo} alt="Website Logo" className="h-16 mb-4 absolute top-2 left-2" /> {/* Sample logo */}
          <img src={errorAvatar} alt="Error Avatar" className="h-[20vh] mb-4" /> {/* Error avatar image */}
          <h1 className="text-[25px] font-bold mb-4 text-[#FF7B55]">Unexpected Issue Detected</h1>
          {/* <div className="w-3/4 text-center"> <p className="text-lg font-semibold">Error Message:</p> <code className="block bg-gray-200 p-4 rounded-md... */}
          <p className="text-lg mt-8">
            An unexpected error has occurred. We apologize for the inconvenience. Please try refreshing the page or contact support at support@trevex.io if the issue persists.
          </p>
          <p className="text-lg mt-4">
            Alternatively, <Link to="/" className="text-blue-500 cursor-pointer underline">click here</Link> to return to the homepage.
          </p>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
